import React, { Fragment, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link, useParams } from "react-router-dom";
import { GetCoach, StoreCoach } from "./Components/Services";
import RateRender from "../../Common/RateRender/index";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import Loading from "../../Common/Loading";
import { Line, defaults } from "react-chartjs-2";
import { ToDateJalali } from "../../Common/Function";
import Comments from "./Components/Comments";
import { CostRender } from "../../Common/Function";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";

function Single() {
  const { slug } = useParams();

  const initialState = {
    loading: true,
    data: {
      data: null,
      current_page: null,
    },
    form: {
      tag: null,
      type: null,
    },
    btnLoading: false,
  };
  const [state, setState] = useState(initialState);
  useEffect(() => {
    Handler();
  }, []);

  const Handler = () => {
    setState({ ...state, loading: true });
    GetCoach(slug).then(result => {
      setState({
        ...state,
        loading: false,
        data: result,
      });
    });
  };

  const RenderDaraje = degree => {
    switch (degree) {
      case "grade_one":
        return "درجه یک";

      case "grade_two":
        return "درجه دو";

      case "grade_theree":
        return "درجه سه";

      case "grade_nationaly":
        return "بین الملل";
    }
  };
  const ItemRender = data => {
    return [
      {
        img: "activee",
        text: "ورزشکاران فعال",
        number:
          data && data.active_athletes_counts && data.active_athletes_counts,
        alt: "ورزشکاران مربی",
      },
      {
        img: "meal",
        text: "برنامه غذایی",
        number:
          data && data.done_diet_plans_counts && data.done_diet_plans_counts,
        alt: "تعدد برنامه های غذایی",
      },
      {
        img: "plan",
        text: "برنامه ورزشی",
        number:
          data && data.done_gym_plans_counts && data.done_gym_plans_counts,
        alt: "تعداد برنامه های ورزشی",
      },
      {
        img: "persons",
        text: "ورزشکاران",
        number:
          data && data.total_athletes_counts && data.total_athletes_counts,
        alt: "ورزشکاران ",
      },
      {
        img: "request",
        text: "درخواست برنامه",
        number: data && data.total_plans_counts && data.total_plans_counts,
        alt: "درخواست برنامه",
      },
      {
        img: "scors",
        text: "امتیازات",
        number:
          data && data.comments_to_coach_avg_score
            ? Math.ceil(parseInt(data.comments_to_coach_avg_score))
            : 0,
        alt: "امتیازات",
      },
    ];
  };
  defaults.font.family = "vazir";
  defaults.font.weight = "700";

  const STYLE = {
    div: "item d-flex flex-column flex-column align-items-center justify-content-center shadow rounded-15",
    p1: "h6 fw-bold mb-3",
    p2: "h5  fw-bold",
  };

  const data = canvas => {
    const ctx = canvas.getContext("2d");
    const gradient = ctx.createLinearGradient(0, 0, 0, 900);
    gradient.addColorStop(0, "#E42A3F19");
    gradient.addColorStop(1, "#de050019");
    const labels = [];
    const values = [];

    if (state.data) {
      state.data.recent_ten_days_plans_counts.map(data => {
        labels.push(ToDateJalali(data.date));
      });
      state.data.recent_ten_days_plans_counts.map(data => {
        values.push(data.value);
      });
    }

    return {
      labels: labels,
      datasets: [
        {
          label: "برنامه ها",
          fill: "start",
          backgroundColor: gradient, // Put the gradient here as a fill color
          borderColor: "#E42A3F ",
          borderWidth: 2,
          pointColor: "#fff",
          pointStrokeColor: "#E42A3F ",
          pointHighlightFill: "#fff",
          pointHighlightStroke: "#E42A3F ",
          data: values,
        },
      ],
    };
  };

  var options = {
    responsive: true,
    datasetStrokeWidth: 3,
    pointDotStrokeWidth: 4,
    tension: 0.3,
    scales: {
      x: {
        grid: {
          display: false,
          drawBorder: false,
          drawOnChartArea: false,
          drawTicks: false,
        },
      },
      y: {
        grid: {
          display: false,
          drawBorder: false,
          drawOnChartArea: false,
          drawTicks: false,
        },
      },
    },
  };

  return (
    <Fragment>
      <Helmet></Helmet>
      {state.loading ? (
        <Loading count={1} col={12} height={600} />
      ) : (
        <section className="single-coach">
          <div className="container">
            <div className="row">
              <SideBar
                details={state.data.coach}
                setState={setState}
                state={state}
              />
              <div className="left col-xxl-9 col-xl-8 col-sm-12 p-2 ps-xl-5">
                <header className="d-flex flex-wrap justify-content-between">
                  <h5 className="mb-3" style={{ color: "#707070" }}>
                    تعداد برنامه های 10 روز اخیر
                  </h5>
                  <h5 className="mb-3" style={{ color: "#707070" }}>
                    {state.data.coach && state.data.coach.total_athletes_counts}
                    برنامه
                  </h5>
                </header>
                <div className="chart mb-4">
                  <Line data={data} options={options} height={60} />
                </div>
                <div className="row medal mb-5">
                  <div className="col-md-auto col-12 d-flex align-items-center">
                    <h5 className="mb-0 text-center w-100">
                      مدال (امتیاز) مربی :{" "}
                      {state.data.coach &&
                        state.data.coach.coach_details &&
                        state.data.coach.coach_details.score}
                    </h5>
                  </div>
                  {window.innerWidth > 768 ? (
                    <div
                      className="col px-0 ms-3 progress position-relative rounded-3"
                      style={{ height: 30 }}
                    >
                      <div
                        className="progress-bar bg-info text-black h-100"
                        role="progressbar"
                        style={{ width: "58%" }}
                        aria-valuenow="33.333"
                        aria-valuemin={0}
                        aria-valuemax="33.333"
                      />
                      <span
                        className="position-absolute top-50 translate-middle-y right fs-6"
                        style={{ right: "2%", mixBlendMode: "multiply" }}
                      >
                        برنز
                      </span>
                      <span
                        className="position-absolute top-50 start-50 translate-middle 
                      3 center fs-6"
                        style={{ mixBlendMode: "multiply" }}
                      >
                        نقره ای
                      </span>
                      <span
                        className="position-absolute top-50 translate-middle-y left fs-6"
                        style={{ left: "2%", mixBlendMode: "multiply" }}
                      >
                        طلایی
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="dashboard d-flex flex-wrap justify-content-xxl-between justify-content-center mb-5">
                  {ItemRender(state.data.coach).map((item, count) => (
                    <div className={STYLE.div} key={count}>
                      <div className={`img ${item.img} mb-3`} />
                      <p className={STYLE.p1}>{item.text}</p>
                      <p className={STYLE.p2}>{item.number}</p>
                    </div>
                  ))}
                </div>
                {state.data &&
                  state.data.coach &&
                  state.data.coach.comments_to_coach &&
                  state.data.coach.comments_to_coach.length === 0 ? (
                  EmptyComment()
                ) : (
                  <div className="others-comment">
                    <h5 className="mb-6">نظر ورزشکاران</h5>
                    <Comments
                      comments={
                        state.data &&
                        state.data.coach &&
                        state.data.coach.comments_to_coach &&
                        state.data.coach.comments_to_coach
                      }
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      )}
    </Fragment>
  );
}
const EmptyComment = () => {
  return <h3 className="text-center"></h3>;
};

const RenderDaraje = degree => {
  switch (degree) {
    case "grade_one":
      return "درجه یک";

    case "grade_two":
      return "درجه دو";

    case "grade_theree":
      return "درجه سه";

    case "grade_nationaly":
      return "بین الملل";
    default:
      return "درجه یک";
  }
};
const SideBar = ({ details, setState, state }) => {
  const { user_type, kind } = useSelector(state => state);
  const dispatch = useDispatch();
  const StoreHandler = state => {
    setState({ ...state, btnLoading: true });
    StoreCoach(state, kind).then(() => {
      setState({
        ...state,
        btnLoading: false,
      });
    });
  };
  const JSX = {
    key: [
      {
        label: "آنلاين",
        id: "gateway",
      },
      {
        label: "کیف پول",
        id: "wallet",
      },
    ],
    title: "نوع پرداخت",
  };
  const STYLE = {
    title: "mb-3",
    container:
      "btns special-btn-input d-flex flex-wrap justify-content-center aling-items-center",
    label: "btn  d-flex flex-wrap align-items-center py-1 px-3 mb-2 mx-1",
    field: "ms-2",
    innerDiv: "bg rounded-15",
  };
  return (
    <div className="main-coach col-xxl-3 col-xl-4 col-lg-6 col-md-7 col-sm-9 mx-auto p-2">
      <div className="shadow text-black rounded-15 part-padding">
        <div className="img mx-auto mb-4">
          <img
            className="rounded-circle w-100"
            src={
              details.profile && details.profile
                ? details.profile
                : window.origin + "/Webside/assets/images/user-img2.png"
            }
            alt={
              details.coach_details
                ? details.coach_details.seo &&
                details.coach_details.seo.seoKeyword &&
                details.coach_details.seo.seoKeyword
                : "nikotan | نیکوتن"
            }
          />
        </div>
        <h5 className="text-center mb-4 name" style={{ color: "#707070" }}>
          {details.fullname}
        </h5>
        <h5
          className="mb-4 rate d-flex justify-content-between"
          style={{ color: "#707070" }}
        >
          <span>مربی</span>
          <span> {RenderDaraje(details.degree)}</span>
        </h5>
        <div className="bio mb-4">
          <h5 className="mb-2" style={{ color: "#707070" }}>
            بیوگرافی : {details.meta_data.bio ? details.meta_data.bio : ""}{" "}
          </h5>
          <p style={{ color: "#707070" }}>
            {details.coach_details && details.coach_details.honors}
          </p>
        </div>
        <div className="coach row align-items-center mb-3">
          <div
            className="price d-flex flex-wrap justify-content-between mb-2 d-flex justify-content-around"
            style={{ color: "#707070" }}
          >
            <h5 className="text-center">درخواست برنامه</h5>
          </div>
          <div className="d-flex align-items-center">
            <p className="mb-0 h6" style={{ color: "#707070" }}>
              رشته ی ورزشی :
            </p>
            <div className="d-flex flex-wrap ">
              {details.tags.map((option, key) => (
                <a
                  key={key}
                  href
                  style={{ color: "rgb(112, 112, 112)", cursor: "pointer" }}
                  onClick={() =>
                    setState({
                      ...state,
                      form: { ...state.form, tag: option.id },
                    })
                  }
                  className={`tags px-2 py-1 rounded-2  many d-flex align-items-center   ${state.form.tag === option.id
                    ? "btn-orange text-white btn "
                    : "btn-light-grey"
                    }`}
                >
                  {option.name}
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className="btns special-btn-input d-flex  justify-content-center aling-items-center">
          <label
            onClick={() =>
              setState({
                ...state,
                form: { ...state.form, type: "Diet" },
              })
            }
            className={`d-flex  align-items-center py-1 px-3 mb-3 mx-1 ${state.form.type === "Diet" ? "btn-orange" : ""
              }`}
          >
            <input type="radio" name="plan" />
            <span
              style={{ whiteSpace: "nowrap", cursor: "pointer" }}
              className="ms-2"
            >
              برنامه غذایی
            </span>
            <div className="bg rounded-15" />
          </label>
          <label
            onClick={() =>
              setState({
                ...state,
                form: { ...state.form, type: "gym" },
              })
            }
            className={`d-flex  align-items-center py-1 px-3 mb-3 mx-1 ${state.form.type === "gym" ? "btn-orange" : ""
              }`}
          >
            <input type="radio" className name="plan" />
            <span
              style={{ whiteSpace: "nowrap", cursor: "pointer" }}
              className="ms-2"
            >
              برنامه ورزشی
            </span>
            <div className="bg rounded-15" />
          </label>
        </div>
        <div
          className="price d-flex flex-wrap justify-content-between mb-2 d-flex justify-content-around"
          style={{ color: "#707070" }}
        >
          <h6 className="text-center">{RenderCost(state)}</h6>
        </div>
        <div className="text-center">
          {user_type === null ? (
            <a
              onClick={() =>
                toast.success("برای دریافت برنامه لطفا ثبت نام کنید")
              }
              style={{ whiteSpace: "nowrap" }}
              className="rounded-15 mb-2 btn btn-orange "
            >
              ثبت درخواست
            </a>
          ) : (
            <Fragment>
              <div>
                <p className={STYLE.title} className="text-right">
                  نوع پرداخت
                </p>
                <div className="btns special-btn-input d-flex flex-wrap justify-content-center aling-items-center">
                  {JSX.key.map((element, count) => (
                    <label

                      key={element.id}
                      onClick={() => {
                        dispatch({
                          type: "SET",
                          payload: { kind: element.id },
                        });
                      }}
                      className={STYLE.label}
                    >
                      <input type="radio" className name="plan" defaultValue />
                      <p className={STYLE.field}>{element.label}</p>
                      <div className={STYLE.innerDiv} />
                    </label>
                  ))}
                </div>
              </div>

              <button
                // disabled={state.btnLoading}
                // disabled={fa}
                onClick={() => StoreHandler(state)}
                style={{ whiteSpace: "nowrap" }}
                className="rounded-15 mb-2 btn btn-orange"
              >
                ثبت درخواست
              </button>
            </Fragment>
          )}
        </div>
      </div>
    </div>
  );
};
const RenderCost = state => {
  if (state.form.tag === null && state.form.type !== null) {
    return "لطفا ورزش مورد نظر خود را انتخاب کنید";
  } else if (state.form.tag !== null && state.form.type === null) {
    return "لطفا برنامه  مورد نظر خود را انتخاب کنید";
  } else if (state.form.tag !== null && state.form.type !== null) {
    let result = "برنامه ای برای انتخاب شما، وجود ندارد.";
    state.data.coach.coach_details &&
      state.data.coach.coach_details.plans_price.map(plan => {
        if (plan.tag_id === state.form.tag && plan.type === state.form.type) {
          result = "قیمت  نهایی : " + CostRender.format(plan.price);
        }
      });
    return result;
  } else {
    return "لطفا برنامه و ورزش خود را وارد کنید";
  }
};
export default Single;
